import {IdObjectsWithId} from "../../../utils";
import {IFileData} from "./types";
import {IFileSystemState} from "../types";

export const mergeFileData = (state: IFileSystemState, data: IdObjectsWithId<IFileData>): IFileSystemState => {
    return {
        ...state,
        filesData: {
            ...state.filesData,
            byId: {
                ...state.filesData.byId,
                ...data.byId
            }
        },
        isSavingFileData: false,
    }
}
export const deleteFileData = (state: IFileSystemState, id: string): IFileSystemState => {
    delete state.filesData.byId[id]
    return {
        ...state,
        filesData: {
            ...state.filesData,
            byId: {
                ...state.filesData.byId
            },
        }
    }

}

